export { default as SvgIcon } from './SvgIcon';
export * from './SvgIcon.types';
